'use strict';
vendorsController.$inject = [
	'$scope',
	'$rootScope',
	'$controller',
	'$q',
	'$uibModal',
	'dialogHelper',
	'VENDOR_STATUS',
	'vendorService',
	'siteService',
	'utilsService',
	'directDepositBankService',
	'purchaseOrderService',
	'purchasingCategoryService',
	'invoiceService',
	'authService',
	'unitService',
	'USER_CLAIMS',
	'USER_CLAIM_TYPES',
	'METHODS_OF_PAYMENT',
	'BUSY_MESSAGE',
	'ROLE_CLAIMS',
];
angular.module('schoolLinqApp').controller('vendorsController', vendorsController);

function vendorsController(
	$scope,
	$rootScope,
	$controller,
	$q,
	$uibModal,
	dialogHelper,
	VENDOR_STATUS,
	vendorService,
	siteService,
	utilsService,
	directDepositBankService,
	purchaseOrderService,
	purchasingCategoryService,
	invoiceService,
	authService,
	unitService,
	USER_CLAIMS,
	USER_CLAIM_TYPES,
	METHODS_OF_PAYMENT,
	BUSY_MESSAGE,
	ROLE_CLAIMS
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;
	$scope.stateHelper = viewModel.stateHelper;

	$scope.$watch(
		'vm.filter.sitesToShow',
		function (sitesToShow) {
			var selectedItems = 0;
			for (var index = 0; index < sitesToShow.length; index++) {
				if (sitesToShow[index].Selected) {
					selectedItems++;
				}

				$scope.vm.filter.numberOfSelectedItems = selectedItems;

				if (selectedItems === sitesToShow.length) {
					$scope.vm.filter.allSelected = true;
				} else {
					$scope.vm.filter.allSelected = false;
				}
			}
		},
		true
	);

	$scope.$watch(
		'vm.backupFilter.sitesToShow',
		function (sitesToShow) {
			if (typeof sitesToShow === 'undefined' || sitesToShow === null) {
				return;
			}

			var selectedItems = 0;
			for (var index = 0; index < sitesToShow.length; index++) {
				if (sitesToShow[index].Selected) {
					selectedItems++;
				}

				$scope.vm.backupFilter.numberOfSelectedItems = selectedItems;

				if (selectedItems === sitesToShow.length) {
					$scope.vm.backupFilter.allSelected = true;
				} else {
					$scope.vm.backupFilter.allSelected = false;
				}
			}
		},
		true
	);

	$scope.$watch(
		'vm.selectedVendorSites',
		function (selectedVendorSites) {
			if (typeof selectedVendorSites === 'undefined' || selectedVendorSites === null) {
				return;
			}

			var selectedItems = 0;
			for (var index = 0; index < selectedVendorSites.length; index++) {
				if (selectedVendorSites[index].Selected) {
					selectedItems++;
				}

				$scope.vm.selectedVendorSitesPaging.numberOfSelectedItems = selectedItems;

				if (selectedItems === selectedVendorSites.length) {
					$scope.vm.selectedVendorSitesPaging.allSelected = true;
				} else {
					$scope.vm.selectedVendorSitesPaging.allSelected = false;
				}
			}
		},
		true
	);

	$scope.$watch(
		'vm.purchaseOrders.filter.fromDT',
		function (fromDT) {
			if (fromDT) {
				$scope.vm.purchaseOrders.filter.startIndex = 0;
				if ($scope.vm.poPageControl.currentPageIndex && $scope.vm.poPageControl.currentPageIndex !== 0) {
					$scope.vm.poPageControl.setPageIndexBack(0);
				}
				$scope.vm.purchaseOrders.filter.fiscalYear = '';
				$scope.vm.searchPurchaseOrders();
			}
		},
		true
	);

	$scope.$watch(
		'vm.purchaseOrders.filter.toDT',
		function (toDT) {
			if (toDT) {
				$scope.vm.purchaseOrders.filter.startIndex = 0;
				if ($scope.vm.poPageControl.currentPageIndex && $scope.vm.poPageControl.currentPageIndex !== 0) {
					$scope.vm.poPageControl.setPageIndexBack(0);
				}
				$scope.vm.purchaseOrders.filter.fiscalYear = '';
				$scope.vm.searchPurchaseOrders();
			}
		},
		true
	);

	$scope.$watch(
		'vm.purchaseOrders.filter.fiscalYear',
		function (fiscalYear) {
			if (fiscalYear) {
				$scope.vm.purchaseOrders.filter.startIndex = 0;
				if ($scope.vm.poPageControl.currentPageIndex && $scope.vm.poPageControl.currentPageIndex !== 0) {
					$scope.vm.poPageControl.setPageIndexBack(0);
				}
				$scope.vm.purchaseOrders.filter.fromDT = null;
				$scope.vm.purchaseOrders.filter.toDT = null;
				$scope.vm.searchPurchaseOrders();
			}
		},
		true
	);

	$scope.$watch(
		'vm.invoices.filter.fromDT',
		function (fromDT) {
			if (fromDT) {
				$scope.vm.invoices.filter.fiscalYear = '';
				$scope.vm.searchInvoices();
			}
		},
		true
	);

	$scope.$watch(
		'vm.invoices.filter.toDT',
		function (toDT) {
			if (toDT) {
				$scope.vm.invoices.filter.fiscalYear = '';
				$scope.vm.searchInvoices();
			}
		},
		true
	);

	$scope.$watch(
		'vm.invoices.filter.fiscalYear',
		function (fiscalYear) {
			if (fiscalYear) {
				$scope.vm.invoices.filter.fromDT = null;
				$scope.vm.invoices.filter.toDT = null;
				$scope.vm.searchInvoices();
			}
		},
		true
	);

	$scope.busyPromise = $q.all([
		$scope.vm.loadVendorStatuses($scope.vm),
		$scope.vm.loadVendors($scope.vm),
		$scope.vm.loadStates($scope.vm),
		$scope.vm.loadBanks($scope.vm),
		$scope.vm.loadBankAccountTypes($scope.vm),
		$scope.vm.loadPurchaseOrderStatus($scope.vm),
		$scope.vm.loadCategories($scope.vm),
		$scope.vm.loadInvoiceStatus($scope.vm),
		$scope.vm.loadSites($scope.vm),
		$scope.vm.loadTINTypes($scope.vm),
		$scope.vm.loadVendor1099Boxes($scope.vm),
		$scope.vm.loadNextVendorCode($scope.vm),
		$scope.vm.loadPaymentMethods($scope.vm),
	]);

	function getViewModel(moduleName) {
		var fieldClaims = authService.authentication.fieldClaims;
		var docMgmtPermission = null; // authService.hasPageClaim(payableClaims, 'VendorsDocMgmt', USER_CLAIMS.fund, 'payable');
		var docMgmtInvoicePermission = null; // authService.hasPageClaim(payableClaims, 'ManageInvoicesDocMgmt', USER_CLAIMS.fund, 'payable');
		var model = {
			module: moduleName,
			vendorsStatuses: [],
			vendors: [],
			banks: [],
			states: [],
			stateHelper: {
				getStateLabel: function (countryCode) {
					if (!countryCode || $scope.vm.states.length === 0) return 'State';

					var country = _.find($scope.vm.states, function (c) {
						return c.CountryCode === countryCode;
					});
					return country.LabelName;
				},
				filterStates: function (countryCode) {
					if (!countryCode || $scope.vm.states.length === 0) return;

					var country = _.find($scope.vm.states, function (c) {
						return c.CountryCode === countryCode;
					});
					return country.StateCodes;
				},
			},
			bankAccountTypes: [],
			categories: [],
			paymentMethods: [],
			tinTypes: [],
			vendor1099Boxes: [],
			canDeleteSelectedVendor: false,
			selectedVendor: null,
			backupVendor: null,
			nextVendorCode: null,
			sites: [],
			selectedVendorSites: null,
			backupVendorSites: null,
			METHODS_OF_PAYMENT: METHODS_OF_PAYMENT,
			postalCodeMinLength: '0',
			selectedVendorSitesPaging: {
				search: '',
				pageSize: 8,
				startIndex: 0,
				numberOfSelectedItems: 0,
				allSelected: true,
			},
			pageSize: 12,
			startIndex: 0,
			numberOfVendors: 0,
			pageControl: {},
			poPageControl: {},
			currentSelectedStatusId: VENDOR_STATUS.Active,
			currentSearchText: '',
			filter: {
				tab: 'General',
				search: {
					statusId: VENDOR_STATUS.Active,
					searchText: '',
				},
				statuses: [],
				sitesToShow: [],
				propertyName: 'ShortName',
				reverse: false,
			},
			vendorPaging: {
				taxId: '',
				searchText: '',
				statusId: VENDOR_STATUS.Active,
				pageSize: 12,
				startIndex: 0,
				orderBy: 'ShortName',
				orderByDescending: false,
			},
			purchaseOrders: {
				purchaseOrders: [],
				purchaseOrderStatus: [],
				fiscalYears: [],
				propertyName: 'PONumber',
				reverse: false,
				totalPurchaseOrders: 0,
				filter: {
					statusId: 0,
					fromDTOpened: false,
					toDTOpened: false,
					fiscalYear: null,
					fromDT: null,
					toDT: null,
					pageSize: 8,
					startIndex: 0,
				},
			},
			invoices: {
				invoices: [],
				invoiceStatus: [],
				fiscalYears: [],
				pageSize: 8,
				startIndex: 0,
				propertyName: 'InvoiceNumber',
				reverse: false,
				filter: {
					statusId: 1,
					fromDTOpened: false,
					toDTOpened: false,
					fiscalYear: null,
					fromDT: null,
					toDT: null,
				},
			},
			busyMessage: BUSY_MESSAGE.Loading,
			errors: null,
			canAccessAllSites: authService.canAccessAll(USER_CLAIM_TYPES.SITE),
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'Vendors', 'payable'),
			requireRequisition: false,
			docMgmt: {
				permissionLevel: docMgmtPermission,
				hasConfidentialAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementVendorsDocMgmtConfidential,
				}),
				hasDeleteAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementVendorsDocMgmtDelete,
				}),
			},
			invoiceDocMgmt: {
				permissionLevel: docMgmtInvoicePermission,
				hasConfidentialAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtConfidential,
				}),
				hasDeleteAccess: !!_.findWhere(fieldClaims, {
					ClaimValue: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtDelete,
				}),
			},
		};

		function selectAllFilterSites(model) {
			var setTo;
			if (model.backupFilter.allSelected) {
				setTo = false;
			} else {
				setTo = true;
			}
			for (var index = 0; index < model.backupFilter.sitesToShow.length; index++) {
				model.backupFilter.sitesToShow[index].Selected = setTo;
			}
		}

		function selectAllVendorSites(model) {
			var setTo;
			if (!model.selectedVendorSitesPaging.allSelected) {
				setTo = false;
			} else {
				setTo = true;
			}
			for (var index = 0; index < model.selectedVendorSites.length; index++) {
				model.selectedVendorSites[index].Selected = setTo;
			}
		}

		function selectOrderCountry(model, country) {
			model.selectedVendor.OrderCountry = country;
			model.selectedVendor.OrderState = null;
			model.selectedVendor.OrderZip = null;
		}

		function selectRemitCountry(model, country) {
			model.selectedVendor.RemitCountry = country;
			model.selectedVendor.RemitState = null;
			model.selectedVendor.RemitZip = null;
		}

		function formIsDirty() {
			return $scope.generalForm.$dirty || $scope.addressesForm.$dirty || $scope.sitesForm.$dirty;
		}

		function changeTab(model, tab) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.filter.tab = tab;
			}
		}

		function remitSameAsOrder(model) {
			// set the dirty flag if something is getting changed
			if (
				model.selectedVendor.RemitAttn !== model.selectedVendor.OrderAttn ||
				model.selectedVendor.RemitCountry !== model.selectedVendor.OrderCountry ||
				model.selectedVendor.RemitAddress1 !== model.selectedVendor.OrderAddress1 ||
				model.selectedVendor.RemitAddress2 !== model.selectedVendor.OrderAddress2 ||
				model.selectedVendor.RemitCity !== model.selectedVendor.OrderCity ||
				model.selectedVendor.RemitState !== model.selectedVendor.OrderState ||
				model.selectedVendor.RemitZip !== model.selectedVendor.OrderZip ||
				model.selectedVendor.RemitEmail !== model.selectedVendor.OrderEmail ||
				model.selectedVendor.RemitPhone !== model.selectedVendor.OrderPhone ||
				model.selectedVendor.RemitFax !== model.selectedVendor.OrderFax
			) {
				$scope.addressesForm.$dirty = true;
			}
			// update the Remit fields
			model.selectedVendor.RemitAttn = model.selectedVendor.OrderAttn;
			model.selectedVendor.RemitCountry = model.selectedVendor.OrderCountry;
			model.selectedVendor.RemitAddress1 = model.selectedVendor.OrderAddress1;
			model.selectedVendor.RemitAddress2 = model.selectedVendor.OrderAddress2;
			model.selectedVendor.RemitCity = model.selectedVendor.OrderCity;
			model.selectedVendor.RemitState = model.selectedVendor.OrderState;
			model.selectedVendor.RemitZip = model.selectedVendor.OrderZip;
			model.selectedVendor.RemitEmail = model.selectedVendor.OrderEmail;
			model.selectedVendor.RemitPhone = model.selectedVendor.OrderPhone;
			model.selectedVendor.RemitFax = model.selectedVendor.OrderFax;
		}

		function save(model) {
			if (
				model.selectedVendor.IsParentVendor &&
				model.backupVendor.StatusId === VENDOR_STATUS.Active &&
				model.selectedVendor.StatusId != model.backupVendor.StatusId
			) {
				dialogHelper.yesnoMessageBox('This vendor has children, are you sure you want to deactivate it?', null, null, null, confirmSave);
			} else {
				confirmSave();
			}

			function confirmSave() {
				$scope.generalForm.$setSubmitted();
				$scope.addressesForm.$setSubmitted();
				if (model.filter.tab === 'Addresses') {
					var isValid;
					// validate OrderZip
					$scope.addressesForm.zip.$setValidity('validZip', true);
					$scope.addressesForm.postalCodeCA.$setValidity('validZip', true);
					$scope.addressesForm.postalCodeOther.$setValidity('validZip', true);
					if (
						(model.selectedVendor.OrderCity && model.selectedVendor.OrderCity.length > 0) ||
						(model.selectedVendor.OrderState && model.selectedVendor.OrderState.length > 0) ||
						(model.selectedVendor.OrderZip && model.selectedVendor.OrderZip.length > 0)
					) {
						isValid = isPostalCodeValid(model.selectedVendor.OrderCountry, model.selectedVendor.OrderZip);
						switch (model.selectedVendor.OrderCountry) {
							case 'US':
								$scope.addressesForm.zip.$setValidity('validZip', isValid);
								break;
							case 'CA':
								$scope.addressesForm.postalCodeCA.$setValidity('validZip', isValid);
								break;
							default:
								$scope.addressesForm.postalCodeOther.$setValidity('validZip', isValid);
								break;
						}
					}
					// validate RemitZip
					$scope.addressesForm.remitZip.$setValidity('validZip', true);
					$scope.addressesForm.remitPostalCodeCA.$setValidity('validZip', true);
					$scope.addressesForm.remitPostalCodeOther.$setValidity('validZip', true);
					if (
						(model.selectedVendor.RemitCity && model.selectedVendor.RemitCity.length > 0) ||
						(model.selectedVendor.RemitState && model.selectedVendor.RemitState.length > 0) ||
						(model.selectedVendor.RemitZip && model.selectedVendor.RemitZip.length > 0)
					) {
						isValid = isPostalCodeValid(model.selectedVendor.RemitCountry, model.selectedVendor.RemitZip);
						switch (model.selectedVendor.OrderCountry) {
							case 'US':
								$scope.addressesForm.remitZip.$setValidity('validZip', isValid);
								break;
							case 'CA':
								$scope.addressesForm.remitPostalCodeCA.$setValidity('validZip', isValid);
								break;
							default:
								$scope.addressesForm.remitPostalCodeOther.$setValidity('validZip', isValid);
								break;
						}
					}
				}
				if (
					model.isReadOnly ||
					(!$scope.generalForm.$valid && model.filter.tab === 'General') ||
					(!$scope.addressesForm.$valid && model.filter.tab === 'Addresses') ||
					(!$scope.sitesForm.$valid && model.filter.tab === 'Sites')
				)
					return false;

				var associatedSiteIds = _.map(
					model.selectedVendorSites.filter(function (value) {
						return value.Selected === true;
					}),
					function (currentObject) {
						return currentObject.Id;
					}
				);

				model.selectedVendor.AssociatedSiteIds = associatedSiteIds;
				model.busyMessage = BUSY_MESSAGE.Saving;
				$scope.busyPromise = vendorService.updateVendor(model.selectedVendor).then(_.partial(finishSaving, model));

				function finishSaving(model, response) {
					if (response.data.isValid) {
						$scope.generalForm.$setPristine();
						$scope.addressesForm.$setPristine();
						$scope.sitesForm.$setPristine();
						model.backupVendor = angular.copy(model.selectedVendor);
						model.backupVendorSites = angular.copy(model.selectedVendorSites);

						model.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = model.loadVendors().then(function () {
							model.selectedVendorSitesPaging.startIndex = 0;
							if (model.selectedVendor) return model.selectVendor(model.selectedVendor.Id);
							else return;
						});
					} else {
						model.errors = response.data.errors;
					}
				}
			}
		}

		function cancelSave(model) {
			model.errors = null;
			$scope.generalForm.$setPristine();
			$scope.addressesForm.$setPristine();
			$scope.sitesForm.$setPristine();
			$scope.generalForm.$setUntouched();
			$scope.addressesForm.$setUntouched();
			$scope.sitesForm.$setUntouched();
			model.selectedVendor = angular.copy(model.backupVendor);
			model.selectedVendorSites = angular.copy(model.backupVendorSites);
		}

		function selectVendor(model, id) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.purchaseOrders.filter.fiscalYear = null;
				model.invoices.filter.fiscalYear = null;
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = vendorService
					.getVendor(id)
					.then(_.partial(finishLoadingVendor, model))
					.then(function () {
						model.loadPurchaseOrderFiscalYears();
						model.loadInvoicesFiscalYears();
						return angular.noop;
					});
			}

			function finishLoadingVendor(model, response) {
				if (response.data.isValid === false) {
					model.errors = response.data.errors;
					return angular.noop;
				}
				model.errors = null;
				//// if a new vendor was selected then start on the General tab
				//if (model.selectedVendor == null || model.selectedVendor.Id != response.data.vendor.Id)
				//    model.filter.tab = 'General';
				model.selectedVendor = response.data.vendor;
				model.selectedVendor.EFT = false;
				if (model.selectedVendor.MethodOfPaymentId && model.selectedVendor.MethodOfPaymentId === METHODS_OF_PAYMENT.EFT) {
					model.selectedVendor.EFT = true;
				}
				if (response.data.vendor.InsuranceExpireDT !== null) {
					model.selectedVendor.InsuranceExpireDT = moment(model.selectedVendor.InsuranceExpireDT).toDate();
				}
				// if there is no Country then select 'US' as the default
				if (!model.selectedVendor.OrderCountry) {
					model.selectedVendor.OrderCountry = 'US';
				}
				if (!model.selectedVendor.RemitCountry) {
					model.selectedVendor.RemitCountry = 'US';
				}
				model.canDeleteSelectedVendor = response.data.canDelete;
				model.selectedVendorSites = [];
				for (var index = 0; index < model.filter.sitesToShow.length; index++) {
					var siteIdActive = model.selectedVendor.VendorSites
						? model.selectedVendor.VendorSites.filter(function (value) {
								return value.SiteId === model.filter.sitesToShow[index].Id;
						  }).length > 0
						: 0;

					model.selectedVendorSites.push({
						SiteName: model.filter.sitesToShow[index].SiteName,
						Id: model.filter.sitesToShow[index].Id,
						Selected: siteIdActive,
					});
				}

				model.selectedVendorSites = model.selectedVendorSites.sort(function (a, b) {
					if (a.Selected === true && b.Selected === false) {
						return -1;
					} else if (a.Selected === false && b.Selected === true) {
						return 1;
					} else {
						if (a.SiteName < b.SiteName) {
							return -1;
						} else if (a.SiteName > b.SiteName) {
							return 1;
						} else {
							return 0;
						}
					}
				});

				model.backupVendor = angular.copy(model.selectedVendor);
				model.backupVendorSites = angular.copy(model.selectedVendorSites);
				return angular.noop;
			}
		}

		function addVendor(model) {
			dialogHelper.dirtyDialog(model.formIsDirty, resetForm, null, acceptFunction);

			function acceptFunction() {
				model.showAddVendor(model);
			}

			function resetForm() {
				model.selectedVendor = null;
				$scope.generalForm.$setPristine();
				$scope.addressesForm.$setPristine();
			}
		}

		function showAddVendor(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/payable/vendor-add-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'vendorService',
						function ($scope, modalInstance, vendorService) {
							$scope.newVendor = {
								ShortName: model.nextVendorCode,
								VendorName: null,
								FederalTaxID: null,
								RemitAttn: null,
								RemitCountry: 'US',
								RemitAddress1: null,
								RemitAddress2: null,
								RemitCity: null,
								RemitState: null,
								RemitZip: null,
							};
							angular.extend($scope, {
								cancel: function () {
									model.errors = null;
									modalInstance.close();
								},
								save: function () {
									var isValid;
									// validate Zip
									$scope.vendorForm.remitZip.$setValidity('validZip', true);
									$scope.vendorForm.remitPostalCodeCA.$setValidity('validZip', true);
									$scope.vendorForm.remitPostalCodeOther.$setValidity('validZip', true);
									if (
										$scope.newVendor.RemitCountry &&
										$scope.newVendor.RemitCountry.length > 0 &&
										$scope.newVendor.RemitZip &&
										$scope.newVendor.RemitZip.length > 0
									) {
										isValid = isPostalCodeValid($scope.newVendor.RemitCountry, $scope.newVendor.RemitZip);
										switch ($scope.newVendor.RemitCountry) {
											case 'US':
												$scope.vendorForm.remitZip.$setValidity('validZip', isValid);
												break;
											case 'CA':
												$scope.vendorForm.remitPostalCodeCA.$setValidity('validZip', isValid);
												break;
											default:
												$scope.vendorForm.remitPostalCodeOther.$setValidity('validZip', isValid);
												break;
										}
									}
									if (!$scope.vendorForm.$valid) return false;

									$scope.savingPromise = vendorService.addVendor($scope.newVendor).then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(response.data.data.Id);
											loadNextVendorCode(model);
										} else {
											model.errors = response.data.errors;
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (vendorId) {
					if (vendorId) {
						model.vendorPaging.statusId = VENDOR_STATUS.Active;
						refreshVendor(model, vendorId);
					}
				});
		}

		function refreshVendor(model, vendorId) {
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = loadVendors($scope.vm)
				.then(function () {
					return model.getPageIndexForVendor({ Id: vendorId });
				})
				.then(function (pageIndex) {
					model.pageControl.setPageIndex(pageIndex);
					return model.selectVendor(vendorId);
				});
		}

		function deleteVendor(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/payable/vendor-delete-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'vendorService',
						function ($scope, modalInstance, vendorService) {
							angular.extend($scope, {
								cancel: function () {
									modalInstance.close(false);
								},
								deleteVendor: function () {
									$scope.deletingPromise = vendorService.deleteVendor($scope.vm.selectedVendor.Id).then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											model.errors = response.data.errors;
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (success) {
					if (success) {
						model.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = loadVendors($scope.vm).then(function () {
							$scope.vm.selectedVendor = null;
						});
					}
				});
		}

		function loadBanks(model) {
			if (model.module === 'sa') {
				return angular.noop;
			}
			return directDepositBankService.getAllDirectDepositBanks().then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;
				model.banks.unshift({
					Id: null,
					BankName: 'Select',
					DisplayName: 'Select',
				});
				return angular.noop;
			}
		}

		function getPageIndexForVendor(model, vendor) {
			model.vendorPaging.vendorId = vendor.Id;

			return vendorService.getPageIndexForVendor(model.vendorPaging).then(_.partial(finishGetPageIndex, model));

			function finishGetPageIndex(model, response) {
				return response.data;
			}
		}

		function loadVendors(model) {
			return vendorService.getVendorsByPage(model.vendorPaging).then(_.partial(finishLoadingVendors, model));

			function finishLoadingVendors(model, response) {
				model.numberOfVendors = response.data.totalNumberOfVendors;
				model.vendors = response.data.vendors;
				if (model.selectedVendor !== null) {
					let found = _.find(model.vendors, function (obj) {
						return obj.Id === model.selectedVendor.Id;
					});
					if (found === undefined) model.selectedVendor = null;
				}
				return angular.noop;
			}
		}

		function changePage(model) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, backFunction, acceptFunction);

			function acceptFunction() {
				model.currentSelectedStatusId = model.vendorPaging.statusId;
				//If the search text changes, it should reset to the first page of data
				model.vendorPaging.startIndex = model.currentSearchText === model.vendorPaging.searchText ? model.pageControl.startIndex : 0;
				model.currentSearchText = model.vendorPaging.searchText;
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = model.loadVendors();
			}

			function backFunction() {
				// cleanup/reset
				model.vendorPaging.statusId = model.currentSelectedStatusId;
				model.vendorPaging.searchText = model.currentSearchText;
				if (model.pageControl.previousPageIndex !== model.pageControl.currentPageIndex)
					model.pageControl.setPageIndexBack(model.pageControl.previousPageIndex);
				return angular.noop;
			}
		}

		function changePoPage(model) {
			model.purchaseOrders.filter.startIndex = model.poPageControl.startIndex;
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = model.searchPurchaseOrders(model);
		}

		function loadStates(model) {
			return utilsService.getStates().then(_.partial(finishLoadingStates, model));

			function finishLoadingStates(model, response) {
				model.states = response.data.states;
				return angular.noop;
			}
		}

		function loadVendorStatuses(model) {
			return utilsService.getVendorStatuses().then(_.partial(finishLoadingVendorStatuses, model));

			function finishLoadingVendorStatuses(model, response) {
				model.vendorsStatuses = response.data.vendorStatuses;
				model.filter.statuses = angular.copy(model.vendorsStatuses);
				angular.forEach(model.filter.statuses, function (value, key) {
					value.Description += ' Vendor';
				});
				return angular.noop;
			}
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishedLoadingSites, model));

			function finishedLoadingSites(model, response) {
				model.startIndex = 0;
				for (var index = 0; index < response.data.sites.length; index++) {
					model.filter.sitesToShow.push({
						SiteName: response.data.sites[index].SiteName,
						Id: response.data.sites[index].Id,
						Selected: true,
					});
				}

				model.filter.sitesToShow = model.filter.sitesToShow.sort(function (a, b) {
					if (a.SiteName < b.SiteName) {
						return -1;
					} else if (a.SiteName > b.SiteName) {
						return 1;
					} else {
						return 0;
					}
				});

				model.backupFilter = angular.copy(model.filter);
				return angular.noop;
			}
		}

		function loadPurchaseOrderStatus(model) {
			return utilsService.getPurchaseOrderStatuses().then(_.partial(finishLoadingPurchaseOrderStatuses, model));

			function finishLoadingPurchaseOrderStatuses(model, response) {
				model.purchaseOrders.purchaseOrderStatus = _.filter(response.data.purchaseOrderStatus, function (status) {
					return status.Id !== 3;
				});
				model.purchaseOrders.purchaseOrderStatus.unshift({
					Id: [1, 2],
					Description: 'All',
				});
				model.purchaseOrders.filter.statusId = model.purchaseOrders.purchaseOrderStatus[0].Id;
				return angular.noop;
			}
		}

		function loadPurchaseOrderFiscalYears(model) {
			return purchaseOrderService
				.getPurchaseOrderFiscalYearsByVendorId(model.selectedVendor.Id)
				.then(_.partial(finishLoadingFiscalYears, model));

			function finishLoadingFiscalYears(model, response) {
				model.purchaseOrders.fiscalYears = response.data.fiscalYears;

				if (typeof model.purchaseOrders.fiscalYears !== 'undefined') {
					model.purchaseOrders.fiscalYears.splice(0, 0, '');
				}

				model.purchaseOrders.filter.fiscalYear = response.data.currentYear;
				return angular.noop;
			}
		}

		function loadInvoicesFiscalYears(model) {
			return invoiceService.getFiscalYearsByVendorId(model.selectedVendor.Id).then(_.partial(finishLoadingFiscalYears, model));

			function finishLoadingFiscalYears(model, response) {
				model.invoices.fiscalYears = response.data.fiscalYears;

				if (typeof model.invoices.fiscalYears !== 'undefined') {
					model.invoices.fiscalYears.splice(0, 0, '');
				}

				model.invoices.filter.fiscalYear = response.data.currentYear;
				return angular.noop;
			}
		}

		function searchPOs() {
			model.purchaseOrders.filter.startIndex = 0;
			if (model.poPageControl.currentPageIndex && model.poPageControl.currentPageIndex !== 0) {
				model.poPageControl.setPageIndexBack(0);
			}
			model.searchPurchaseOrders();
		}

		function searchPurchaseOrders(model) {
			var filter = {
				search: null,
				fiscalYear: model.purchaseOrders.filter.fiscalYear,
				statusId: model.purchaseOrders.filter.statusId,
				fromDT: model.purchaseOrders.filter.fromDT,
				toDT: model.purchaseOrders.filter.toDT,
				vendorId: model.selectedVendor.Id,
				onlyIncludeDelivered: false,
				purchasingType: 2,
				propertyName: model.purchaseOrders.propertyName,
				reverse: model.purchaseOrders.reverse,
				pageSize: model.purchaseOrders.filter.pageSize,
				startIndex: model.purchaseOrders.filter.startIndex,
			};

			$scope.searchingPosPromise = purchaseOrderService.searchPurchaseOrders(filter).then(_.partial(finishSearchingPurchaseOrders, model));

			function finishSearchingPurchaseOrders(model, response) {
				model.purchaseOrders.purchaseOrders = response.data.PurchaseOrders;
				model.purchaseOrders.totalPurchaseOrders = response.data.Total;

				return angular.noop;
			}
		}

		function displayPurchaseOrder(model, poId) {
			model.errors = '';

			var purchaseOrderScope = $scope.$new();
			$controller('purchasingPurchaseOrdersController', {
				$scope: purchaseOrderScope,
			});
			purchaseOrderScope.vm.isReadOnly = true;

			// set a watch on a state variable so we can know when the user is done view/editing
			// then we can update the list so it will reflect any changes made
			// *this is only needed if/when we allow the user to edit from here
			//purchaseOrderScope.$watch("vm.newEditState", function (state) {
			//    if (state == 'Done') {
			//        model.searchPurchaseOrders();
			//    }
			//}, true);

			purchaseOrderScope.vm.newEditPurchaseOrder(poId);
		}

		function searchInvoices(model) {
			var filter = {
				fiscalYear: model.invoices.filter.fiscalYear,
				statusId: model.invoices.filter.statusId,
				fromDate: model.invoices.filter.fromDT,
				toDate: model.invoices.filter.toDT,
				vendor: { Id: model.selectedVendor.Id },
				excludeVoided: false,
			};

			$scope.searchingInvoicePromise = invoiceService.searchInvoices(filter).then(_.partial(finishSearchingInvoices, model));

			function finishSearchingInvoices(model, response) {
				var invoices = [];
				angular.forEach(
					response.data,
					function (invoice, key) {
						var j, i;
						if (model.invoices.filter.statusId === 3) {
							// Paid, show check amounts
							for (j = 0; j < invoice.InvoiceChecks.length; j++) {
								this.push({
									Id: invoice.Id,
									InvoiceNumber: invoice.InvoiceNumber,
									Bank: invoice.InvoiceChecks[j].Bank,
									Amount: invoice.InvoiceChecks[j].Amount,
									CheckNumber: invoice.InvoiceChecks[j].CheckNumber,
									CheckDT: invoice.InvoiceChecks[j].CheckDT,
									VoidDT: invoice.InvoiceChecks[j].VoidDT,
									PONumber: invoice.PONumber,
									SiteName: invoice.SiteName,
								});
							}
						} else if (model.invoices.filter.statusId === 1) {
							// Unpaid, show InvoiceAccount totals
							for (i = 0; i < invoice.InvoiceAccounts.length; i++) {
								if (invoice.InvoiceAccounts[i].InvoiceCheckId === null) {
									this.push({
										Id: invoice.Id,
										InvoiceNumber: invoice.InvoiceNumber,
										Bank: invoice.InvoiceAccounts[i].Bank,
										Amount: invoice.InvoiceAccounts[i].Total,
										PONumber: invoice.PONumber,
										SiteName: invoice.SiteName,
									});
								}
							}
						} else {
							if (invoice.InvoiceChecks.length > 0) {
								for (j = 0; j < invoice.InvoiceChecks.length; j++) {
									this.push({
										Id: invoice.Id,
										InvoiceNumber: invoice.InvoiceNumber,
										Bank: invoice.InvoiceChecks[j].Bank,
										Amount: invoice.InvoiceChecks[j].Amount,
										CheckNumber: invoice.InvoiceChecks[j].CheckNumber,
										CheckDT: invoice.InvoiceChecks[j].CheckDT,
										VoidDT: invoice.InvoiceChecks[j].VoidDT,
										PONumber: invoice.PONumber,
										SiteName: invoice.SiteName,
									});
								}
							} else {
								for (i = 0; i < invoice.InvoiceAccounts.length; i++) {
									this.push({
										Id: invoice.Id,
										InvoiceNumber: invoice.InvoiceNumber,
										Bank: invoice.InvoiceAccounts[i].Bank,
										Amount: invoice.InvoiceAccounts[i].Total,
										PONumber: invoice.PONumber,
										SiteName: invoice.SiteName,
									});
								}
							}
						}
					},
					invoices
				);
				model.invoices.invoices = invoices;
				return angular.noop;
			}
		}

		function displayInvoice(model, invoiceId) {
			model.errors = '';

			var payableInvoiceScope = $scope.$new();
			$controller('payableInvoicesController', { $scope: payableInvoiceScope });

			// set a watch on a state variable so we can know when the user is done view/editing
			// then we can update the list so it will reflect any changes made
			// *this is only needed if/when we allow the user to edit from here
			//payableInvoiceScope.$watch("vm.newEditState", function (state) {
			//    if (state == 'Done') {
			//        model.searchInvoices();
			//    }
			//}, true);

			payableInvoiceScope.vm.newEditInvoice(invoiceId, false, true);
		}

		function loadBankAccountTypes(model) {
			return utilsService.getPRBankAccountTypes().then(_.partial(finishLoadingBankAccountTypes, model));

			function finishLoadingBankAccountTypes(model, response) {
				model.bankAccountTypes = response.data;
				model.bankAccountTypes.unshift({ Id: null, Description: 'Select' });
				return angular.noop;
			}
		}

		function loadCategories(model) {
			return purchasingCategoryService.list().then(_.partial(finishLoadingCategories, model));

			function finishLoadingCategories(model, response) {
				model.categories = response.data;
				return angular.noop;
			}
		}

		function loadInvoiceStatus(model) {
			return utilsService.getInvoiceStatus().then(_.partial(finishLoadingInvoiceStatus, model));

			function finishLoadingInvoiceStatus(model, response) {
				model.invoices.invoiceStatus = response.data;
				// remove Partial Paid
				model.invoices.invoiceStatus = _.filter(model.invoices.invoiceStatus, function (item) {
					return item.Id !== 2;
				});
				return angular.noop;
			}
		}

		function loadTINTypes(model) {
			return utilsService.getTINTypes().then(_.partial(finishLoadingTINTypes, model));

			function finishLoadingTINTypes(model, response) {
				model.tinTypes = response.data;
			}
		}

		function loadVendor1099Boxes(model) {
			return utilsService.getVendor1099Boxes().then(_.partial(finishLoadingVendor1099Boxes, model));

			function finishLoadingVendor1099Boxes(model, response) {
				model.vendor1099Boxes = response.data;
			}
		}

		function loadNextVendorCode(model) {
			return unitService.getNextVendorCode().then(_.partial(finishLoadingNextVendorCode, model));

			function finishLoadingNextVendorCode(model, response) {
				model.nextVendorCode = response.data.data;
			}
		}

		function loadPaymentMethods(model) {
			return utilsService.getMethodOfPaymentTypes().then(_.partial(finishLoadingMethodOfPaymentTypes, model));

			function finishLoadingMethodOfPaymentTypes(model, response) {
				unitService.getValue('EnabledVirtualCreditCards').then((enableResponse) => {
					const acceptablePaymentTypes = [METHODS_OF_PAYMENT.Check, METHODS_OF_PAYMENT.EFT];

					if (enableResponse.data.value && enableResponse.data.value.toLowerCase() === 'true') {
						acceptablePaymentTypes.push(METHODS_OF_PAYMENT.CreditCard, METHODS_OF_PAYMENT.VirtualCard);
					}

					model.paymentMethods = _.filter(response.data, function (type) {
						return acceptablePaymentTypes.includes(type.Id);
					});
					model.paymentMethods.unshift({ Id: null, Description: 'Select' });
					return angular.noop;
				});
			}
		}

		function sortby(model, propertyName) {
			model.vendorPaging.orderByDescending = model.vendorPaging.orderBy === propertyName ? !model.vendorPaging.orderByDescending : false;
			model.vendorPaging.orderBy = propertyName;
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = model.loadVendors();
		}

		function sortInvoicesBy(model, propertyName) {
			model.invoices.reverse = model.invoices.propertyName === propertyName ? !model.invoices.reverse : false;
			model.invoices.propertyName = propertyName;
		}

		function sortPOsBy(model, propertyName) {
			model.purchaseOrders.reverse = model.purchaseOrders.propertyName === propertyName ? !model.purchaseOrders.reverse : false;
			model.purchaseOrders.propertyName = propertyName;
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = model.searchPurchaseOrders(model);
		}

		function isBankRequired(model) {
			if (!model.selectedVendor) return false;

			if (model.selectedVendor.BankAccountTypeId) return true;

			if (model.selectedVendor.AccountNumberDecrypted) return true;

			return false;
		}

		function isAccountTypeRequired(model) {
			if (!model.selectedVendor) return false;

			if (model.selectedVendor.DirectDepositBankId) return true;

			if (model.selectedVendor.AccountNumberDecrypted) return true;

			return false;
		}

		function isAccountNumberRequired(model) {
			if (!model.selectedVendor) return false;

			if (model.selectedVendor.DirectDepositBankId) return true;

			if (model.selectedVendor.BankAccountTypeId) return true;

			return false;
		}

		function isOrderStateAndZipRequired(model) {
			if (!model.selectedVendor) return false;

			if (model.selectedVendor.OrderCountry === 'US') {
				model.postalCodeMinLength = '0';
				// always returning false because Addresses are not required
				// for vendors; but we still needed a way to set the postalCodeMinLength
				//return true;
			}
			return false;
		}

		function isOrderProvinceAndPostalCodeRequired(model) {
			if (!model.selectedVendor) return false;

			if (model.selectedVendor.OrderCountry === 'CA') {
				model.postalCodeMinLength = '6';
				// always returning false because Addresses are not required
				// for vendors; but we still needed a way to set the postalCodeMinLength
				//return true;
			}
			if (model.selectedVendor.OrderCountry !== 'US' && model.selectedVendor.OrderCountry !== 'CA') {
				model.postalCodeMinLength = '6';
				// always returning false because Addresses are not required
				// for vendors; but we still needed a way to set the postalCodeMinLength
				//return true;
			}

			return false;
		}

		function isRemitStateAndZipRequired(model) {
			if (!model.selectedVendor) return false;

			if (model.selectedVendor.RemitCountry === 'US') {
				model.postalCodeMinLength = '0';
				// always returning false because Addresses are not required
				// for vendors; but we still needed a way to set the postalCodeMinLength
				//return true;
			}
			return false;
		}

		function isRemitProvinceAndPostalCodeRequired(model) {
			if (!model.selectedVendor) return false;

			if (model.selectedVendor.RemitCountry === 'CA') {
				model.postalCodeMinLength = '6';
				// always returning false because Addresses are not required
				// for vendors; but we still needed a way to set the postalCodeMinLength
				//return true;
			}
			if (model.selectedVendor.RemitCountry !== 'US' && model.selectedVendor.RemitCountry !== 'UK') {
				model.postalCodeMinLength = '6';
				// always returning false because Addresses are not required
				// for vendors; but we still needed a way to set the postalCodeMinLength
				//return true;
			}

			return false;
		}

		return angular.extend(model, {
			formIsDirty: formIsDirty,
			changeTab: _.partial(changeTab, model),
			remitSameAsOrder: _.partial(remitSameAsOrder, model),
			save: _.partial(save, model),
			cancelSave: _.partial(cancelSave, model),
			selectVendor: _.partial(selectVendor, model),
			addVendor: _.partial(addVendor, model),
			showAddVendor: _.partial(showAddVendor, model),
			refreshVendor: _.partial(refreshVendor, model),
			deleteVendor: _.partial(deleteVendor, model),
			getPageIndexForVendor: _.partial(getPageIndexForVendor, model),
			changePage: _.partial(changePage, model),
			changePoPage: _.partial(changePoPage, model),
			loadBanks: _.partial(loadBanks, model),
			loadPaymentMethods: _.partial(loadPaymentMethods, model),
			loadVendors: _.partial(loadVendors, model),
			loadStates: _.partial(loadStates, model),
			loadVendorStatuses: _.partial(loadVendorStatuses, model),
			loadBankAccountTypes: _.partial(loadBankAccountTypes, model),
			loadPurchaseOrderStatus: _.partial(loadPurchaseOrderStatus, model),
			searchPOs: _.partial(searchPOs, model),
			searchPurchaseOrders: _.partial(searchPurchaseOrders, model),
			displayPurchaseOrder: _.partial(displayPurchaseOrder, model),
			searchInvoices: _.partial(searchInvoices, model),
			displayInvoice: _.partial(displayInvoice, model),
			loadPurchaseOrderFiscalYears: _.partial(loadPurchaseOrderFiscalYears, model),
			loadInvoicesFiscalYears: _.partial(loadInvoicesFiscalYears, model),
			loadCategories: _.partial(loadCategories, model),
			loadInvoiceStatus: _.partial(loadInvoiceStatus, model),
			loadTINTypes: _.partial(loadTINTypes, model),
			loadVendor1099Boxes: _.partial(loadVendor1099Boxes, model),
			loadNextVendorCode: _.partial(loadNextVendorCode, model),
			sortby: _.partial(sortby, model),
			sortInvoicesBy: _.partial(sortInvoicesBy, model),
			sortPOsBy: _.partial(sortPOsBy, model),
			loadSites: _.partial(loadSites, model),
			selectAllFilterSites: _.partial(selectAllFilterSites, model),
			selectAllVendorSites: _.partial(selectAllVendorSites, model),
			selectOrderCountry: _.partial(selectOrderCountry, model),
			selectRemitCountry: _.partial(selectRemitCountry, model),
			isBankRequired: _.partial(isBankRequired, model),
			isAccountTypeRequired: _.partial(isAccountTypeRequired, model),
			isAccountNumberRequired: _.partial(isAccountNumberRequired, model),
			isOrderStateAndZipRequired: _.partial(isOrderStateAndZipRequired, model),
			isOrderProvinceAndPostalCodeRequired: _.partial(isOrderProvinceAndPostalCodeRequired, model),
			isRemitStateAndZipRequired: _.partial(isRemitStateAndZipRequired, model),
			isRemitProvinceAndPostalCodeRequired: _.partial(isRemitProvinceAndPostalCodeRequired, model),
		});
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}
